import { render, staticRenderFns } from "./packagesDetail.vue?vue&type=template&id=6b4aa640&scoped=true&"
import script from "./packagesDetail.vue?vue&type=script&lang=js&"
export * from "./packagesDetail.vue?vue&type=script&lang=js&"
import style0 from "./packagesDetail.vue?vue&type=style&index=0&id=6b4aa640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4aa640",
  null
  
)

export default component.exports